var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('option-panel', {
    attrs: {
      "active": _vm.currency.active
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click', _vm.currency);
      }
    }
  }, [_c('div', {
    class: _vm.$style.icon,
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_vm._v(_vm._s(_vm.currency.sign))]), _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t(_vm.currency.name)))]), _c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v(_vm._s(_vm.currency.description))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }